import { Outlet } from "react-router-dom";
import PreloadManager from "./PreloadManager";

const AppLayout = () => {
  return (
    <>
      <PreloadManager />
      <Outlet />
    </>
  );
};

export default AppLayout;
